import request from '@/utils/request'

// 推送任务列表
export function list(params = {}) {
  return request({
    url: '/templateMessagePush/list',
    method: 'get',
    params
  })
}

// 去重的公众号模板名称列表
export function templateList(params = {}) {
  return request({
    url: '/templateMessagePush/templateList',
    method: 'get',
    params
  })
}

// 根据模板名称查找appid
export function appIdByTemplateTitle(params = {}) {
  return request({
    url: '/templateMessagePush/appIdByTemplateTitle',
    method: 'get',
    params
  })
}
// 根据模板名称查找模板
export function oneTemplate(params = {}) {
  return request({
    url: '/templateMessagePush/oneTemplate',
    method: 'get',
    params
  })
}
// 推送任务详情
export function infoList(params = {}) {
  return request({
    url: '/templateMessagePush/infoList',
    method: 'get',
    params
  })
}
// 推送任务中停止推送
export function stopSendPushInfo(params = {}) {
  return request({
    url: '/templateMessagePush/stopSendPushInfo',
    method: 'get',
    params
  })
}
// 推送任务停止
export function stopSendPush(params = {}) {
  return request({
    url: '/templateMessagePush/stopSendPush',
    method: 'get',
    params
  })
}
// 保存模板消息推送任务
export function store(data) {
  return request({
    url: '/templateMessagePush/store',
    method: 'post',
    data
  })
}

// 获取企业标签
export function corpTag(data) {
  return request({
    url: '/spWorkWechat/strategyBind/corpTag',
    method: 'post',
    data
  })
}

// 新建标签组
export function addCorpTag(data) {
  return request({
    url: '/spWorkWechat/corpTag/addCorpTag',
    method: 'post',
    data
  })
}

// 编辑标签
export function editCorpTag(data) {
  return request({
    url: '/spWorkWechat/corpTag/editCorpTag',
    method: 'post',
    data
  })
}

// 为打标签用户的外部客户列表
export function corpExternalUsersListForTag(params = {}) {
  return request({
    url: '/spWorkWechat/spCorp/corpExternalUsersListForTag',
    method: 'get',
    params
  })
}

// 给客户添加标签
export function markTag(data) {
  return request({
    url: '/spWorkWechat/corpTag/markTag',
    method: 'post',
    data
  })
}

// 标签对应的客户
export function corpTagExternalList(params = {}) {
  return request({
    url: '/spWorkWechat/corpTag/corpTagExternalList',
    method: 'get',
    params
  })
}

// 删除标签
export function delCorpTag(data) {
  return request({
    url: '/spWorkWechat/corpTag/delCorpTag',
    method: 'post',
    data
  })
}

// 删除标签组
export function delCorpGroup(data) {
  return request({
    url: '/spWorkWechat/corpTag/delCorpGroup',
    method: 'post',
    data
  })
}
// 刷新标签组
export function refreshTag(data) {
  return request({
    url: '/spWorkWechat/corpTag/refreshTag',
    method: 'post',
    data
  })
}
// 客户详情接口
export function externalDetail(params) {
  return request({
    url: 'spWorkWechat/spCorp/externalDetail',
    method: 'get',
    params
  })
}
// 修改客户标签
export function updateTag(data) {
  return request({
    url: '/spWorkWechat/spCorp/updateTag',
    method: 'post',
    data
  })
}
// 给客户添加标签v2
export function markTagV2(data) {
  return request({
    url: '/spWorkWechat/corpTag/markTagV2',
    method: 'post',
    data
  })
}
